import { createSlice } from '@reduxjs/toolkit';


import { colorPaletteInitialState } from './constants';

const colorPaletteSlice = createSlice({
  name: 'colorPalette',
  initialState: colorPaletteInitialState,
  reducers: {
  },
});


export default colorPaletteSlice.reducer;
